import React , {useState, useEffect}from 'react';
import ReactDOM from 'react-dom';
import { Form, Field, reduxForm } from 'redux-form';
import { RejectReason, RejectOther } from '../../common/input';
import { required } from '../../../util/validate';
import { axiosInstnace as Axios } from '../../../util/util';
import { endPoints } from '../../../config';



const RejectModal = (props) => {

  //Set initial state
const [other, handleOther] =useState("form-group none");
const [errorStatus, handleErrorStatus] =useState(false);
const [otherReason, handleOtherReason] = useState("")
  const closePopup = () => {
    props.hide();
  }

  //Get reason
   const getReason = v =>{
    const reason = v.target.value ;
    if(reason === "Other"){
      handleOther("form-group")
    }
    else {
      handleOther("form-group none");
      handleOtherReason("");
      handleErrorStatus(false);

    }
  }

  //Get other reason
   const getOtherReason =r =>{
    handleOtherReason(r.target.value);
    handleErrorStatus(false);
   }

   //Submit the rejet model
  const  handleFormSubmit =async values =>{
    if(other === "form-group" && otherReason.length ===0) {
      handleErrorStatus(true);
      return;
    }

    let reason =values.reason;
    if(otherReason.length >0){
       reason = otherReason;
    }
    const params = {
        reason,
        _id: props.campaignId, 
        user_email : props.user_email,
        user_name  :  props.user_name,
        user_mobile  : props.user_mobile,
        user_company : props.user_company,
        user_industry : props.user_industry,
        user_state : props.user_state,
        status: "Audio Rejected",
        audioStatus: "Audio Rejected",
        audiorejectedby: props.user_email,
        changedby: props.changedby
     };
 
    try {
        console.log(params)
      const response = await Axios.put(endPoints.addRemoveCampaign,params);
      if (response.data.statusCode===200) {
        props.hide();
        props.getCampaignlist();
         
      } 
    } catch (error) {

    } 
   }

   //Show reject model
  return(
    props.isRejectShowing?  <div>
 <div className="modal-overlay">
    <div className="modal-wrapper thankyou-popup" aria-modal aria-hidden tabIndex={-1} role="dialog">
      <div className="modal reject">
        <div className="modal-head-cross rate-modal">
          <button type="button" className="modal-close-button" onClick={closePopup}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
       
        <div className="editNonFct-header modal-header" >
          <h4 className="popup-head rqst-head fct-head modal-title">Request Rejection</h4>
        </div>
        <div className="popup-container reqst-rejection">
            <p className="reqst-para">Please select a reason of rejection from the list</p>
        <ul>
          <li>
            <div className="form-group brand-selector">
              <Field
              name="reason"
              component={RejectReason}
              options={["Creative is not in line with the brief", "Audio quality issue", "Inventory not available", "Other"]}
              validate={[required]}
              onChange={getReason}
            />
            </div>
            <div className={other}>
              <Field
              name="other"
              component={RejectOther}
              errorStatus={errorStatus}
              onChange={getOtherReason}
            />
            </div>
          </li>
        </ul>
        <div className="add-btn-subBrand rqst-cancel-btn">
          <button onClick={props.handleSubmit(handleFormSubmit)}>PROCEED</button>
        </div>
      </div>
      </div>
        </div>
      </div>
    </div>
  </div>:null
  )
}

export default reduxForm({ form: 'reason' })(RejectModal)


// WEBPACK FOOTER //
// ./web/components/admin/audioadminmanagment/rejectModel.js